import { render, staticRenderFns } from "./list_config_dataset_detail_list.vue?vue&type=template&id=650ee0de"
import script from "./list_config_dataset_detail_list.vue?vue&type=script&lang=js"
export * from "./list_config_dataset_detail_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650ee0de')) {
      api.createRecord('650ee0de', component.options)
    } else {
      api.reload('650ee0de', component.options)
    }
    module.hot.accept("./list_config_dataset_detail_list.vue?vue&type=template&id=650ee0de", function () {
      api.rerender('650ee0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/list_config_dataset_detail_list.vue"
export default component.exports